<template>
	<div class="c-variant-add-to-basket">
		<read-only-description v-if="isReadOnlyVariant && !externalPurchaseOnly"
							   :description="formattedLabels.productWhereToBuyBannerText"></read-only-description>
		<template v-if="isReadOnlyVariant && externalPurchaseOnly && selectedVariant">
			<DsText :class="{ 'c-variant-selector__label--disabled': !selectedVariant }"
					style="padding: 16px 0; display: block;"
					html-element="span"
					text-type="heading-2xl"
					text-style="bold">
				{{ vm.BaseViewModel.ProductDetailsSettingsBlock.ChooseOptionLabel }}
			</DsText>
			<div class="c-variant-add-to-basket__option">
				<div class="c-variant-add-to-basket__main">
					<input id="add-to-basket-action-buy"
						   type="radio"
						   name="addToBasketAction"
						   class="c-variant-add-to-basket__radio"
						   checked />
					<DsText for="add-to-basket-action-buy"
							class="c-variant-add-to-basket__label"
							html-element="label"
							text-type="body-lg">
						{{formattedLabels.standardPackLabel}}
					</DsText>
					<div class="c-variant-add-to-basket__only-external-purchase">
						<hr class="c-variant-add-to-basket__divider" />
						<DsText html-element="div">
							<div class="c-variant-add-to-basket__option-description"
								 v-html="insertExternalLink" />
						</DsText>
					</div>
				</div>
			</div>
		</template>
		<template v-if="!isNotAvailableForSale">
			<template v-if="!isReadOnlyVariant">
				<!-- If not hcp product-->
				<template v-if="!hcpProductLayout">
					<DsText v-if="showSampleOnlyComponent"
							class="c-variant-selector__label c-variant-selector__label--large"
							:class="{ 'c-variant-selector__label--disabled': !selectedVariant }"
							html-element="span"
							text-type="heading-2xl"
							text-style="bold">
						{{ vm.BaseViewModel.ProductDetailsSettingsBlock.ChooseOptionLabel }}
					</DsText>
					<!-- Sample Only -->
					<div v-if="showSampleOnlyComponent" class="c-variant-add-to-basket__option" :class="{ 'c-variant-add-to-basket__option--disabled': !selectedVariant }">
						<input id="add-to-basket-action-sample" type="radio" name="addToBasketAction" class="c-variant-add-to-basket__radio" :value="sampleAction" v-model="action" :disabled="!selectedVariant" />
						<label for="add-to-basket-action-sample" class="c-variant-add-to-basket__label">
							<div class="c-variant-add-to-basket__holder">
								<span class="c-variant-add-to-basket__option-title">{{ formattedLabels.wantSample.samplePackLabel }}</span>
							</div>
							<div class="c-variant-add-to-basket__main">
								<hr class="c-variant-add-to-basket__divider" />
								<div class="c-variant-add-to-basket__header">
									<span class="c-variant-add-to-basket__option-label">{{ formattedLabels.wantSample.samplePackRadioLabel }}</span>
									<span class="c-variant-add-to-basket__option-price">{{ formattedLabels.wantSample.freeSampleLabel }}</span>
								</div>
								<div class="c-variant-add-to-basket__option-description" v-html="showCorrectSampleDescription"></div>
							</div>
						</label>
					</div>
					<!-- External Purchase Only -->
					<div v-if="externalPurchaseOnly"
						 class="c-variant-add-to-basket__option"
						 :class="{ 'c-variant-add-to-basket__option--disabled': !selectedVariant }">
						<input id="add-to-basket-action-buy"
							   type="radio"
							   name="addToBasketAction"
							   class="c-variant-add-to-basket__radio"
							   :value="buyAction"
							   v-model="action"
							   :disabled="!selectedVariant" />
						<label for="add-to-basket-action-buy"
							   class="c-variant-add-to-basket__label">
							<div class="c-variant-add-to-basket__holder">
								<span class="c-variant-add-to-basket__option-title">{{ formattedLabels.standardPackLabel }}</span>
							</div>
							<div class="c-variant-add-to-basket__main"
								 v-if="externalPurchaseOnly && action">
								<hr class="c-variant-add-to-basket__divider" />
								<div class="c-variant-add-to-basket__option-description"
									 v-if="externalPurchaseOnly && action"
									 v-html="insertExternalLink"></div>
							</div>
						</label>
					</div>
					<DsButtonGroup v-if="showAddToBasketButton"
								   desktop-alignment="stretch"
								   class="c-variant-add-to-basket__add-btn-container">
						<DsButton type="button"
								  @click="addProductToBasket()"
								  :disabled="action === ''"
								  variant="primary">
							{{ formattedLabels.addToBasketButton.addSampleToBasketLabel }}
						</DsButton>
					</DsButtonGroup>
				</template>
				<!-- If hcp product-->
				<template v-else>
					<DsButton v-if="!isSampleInBasket"
							  type="button"
							  @click="addProductToBasket()"
							  :disabled="action === ''"
							  variant="primary"
							  icon-end="shopping-basket"
							  size="md">
						{{ formattedLabels.addToBasketButton.addSampleToBasketLabel }}
					</DsButton>
					<read-only-description v-else
										   :description="formattedLabels.wantSample.variantIsAlreadyInBasketMessage">

					</read-only-description>
	    		</template>
			</template>
			<DsButtonGroup v-if="showExternalPurchaseButton"
						   desktop-alignment="stretch"
						   class="c-variant-add-to-basket__add-btn-container">
				<DsButton :href="vm.BaseViewModel?.ExternalSiteBuyUrl"
						  data-testid="button-add-to-basket"
						  variant="primary">
					{{ vm.BaseViewModel?.ProductDetailsSettingsBlock?.ExternalBuyButtonLabel || vm.BaseViewModel?.ProductDetailsSettingsBlock?.ExternalBuyUrlLabel }}
				</DsButton>
			</DsButtonGroup>
		</template>
	</div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import ReadOnlyDescription from 'shared/components/product/detailViewComponents/readOnlyDescription.vue';
import {addToBasketActions, sampleAndPurchaseStates} from 'shared/settings/constants';
import Events from "shared/settings/events";
import AddSampleToBasketService from 'shared/services/addSampleTobasketService';
import { DsButton, DsButtonGroup, DsText } from '@coloplast/design-system';
import { track_add_to_cart } from 'shared/services/tracking/basketTrackingService.ts';

export default {
	name: "add-sample-to-basket",
	components: {
		ReadOnlyDescription,
		DsButton,
		DsButtonGroup,
		DsText,
	},
	props: {
		vm: {
			type: Object,
			required: true,
		},
		hcpProductLayout: {
			type: Boolean,
			default: false,
		},
		currency: {
			type: String,
			required: true
		},
		language: {
			type: String,
			required: true
		},
		trackingCategories: {
			type: Object,
			required: true
		},
		productName: {
			type: String,
			required: true
		},
		productCode: {
			type: String,
			required: true
		},
		brandName: {
			type: String,
			required: true
		},
	},
	emits: ['itemsAddedToTheBasket'],
	data() {
		return {
			action: '',
			initialAction: '',
			sampleAction: addToBasketActions.SAMPLE,
			buyAction: addToBasketActions.BUY,
			stateIndicator: this.vm.BaseViewModel.ProcessIndicatorState,
		}
	},
	computed: {
		...mapGetters({
			selectedVariant: 'getSelectedVariant',
			variants: 'getVariants',
			marketId: 'getMarketId',
		}),
		isReadOnlyVariant() {
			if(this.selectedVariant) {
				return this.selectedVariant.ProcessIndicatorState == sampleAndPurchaseStates.IS_READ_ONLY;
			}

			return this.stateIndicator === sampleAndPurchaseStates.IS_READ_ONLY;
		},
		isNotAvailableForSale() {
			return this.isReadOnlyVariant && !this.vm.BaseViewModel?.ExternalSiteBuyUrl;
		},
		formattedLabels() {
			const productLabels = this.vm.BaseViewModel.ProductDetailsSettingsBlock;
			return {
				wantSample: {
					samplePackLabel: productLabels.SamplePackLabel,
					samplePackRadioLabel: productLabels.SamplePackRadioLabel,
					sampleRadioDescriptionText: productLabels.SampleRadioDescriptionText,
					samplePlaceholderRadioDescriptionText: productLabels.SamplePlaceholderRadioDescriptionText,
					freeSampleLabel: productLabels.FreeSampleLabel,
					variantIsAlreadyInBasketMessage: productLabels.VariantIsAlreadyInBasketMessage,
				},
				addToBasketButton: {
					addToBasketLabel: productLabels.AddToBasketLabel,
					addSampleToBasketLabel: productLabels.AddSampleToBasketLabel
				},
				standardPackLabel: productLabels.StandardPackLabel,
				productWhereToBuyBannerText: this.vm.BaseViewModel.ProductWhereToBuyBannerTextArea,
			}
		},
		dontKnowSize() {
			if(!!this.selectedVariant && this.selectedVariant.IsSamplePlaceHolder) {
				return this.selectedVariant.IsSamplePlaceHolder;
			}
			return false;
		},
		showCorrectSampleDescription() {
			if(this.isSampleInBasket) {
				return this.formattedLabels.wantSample.variantIsAlreadyInBasketMessage;
			}
			return this.dontKnowSize ? this.formattedLabels.wantSample.samplePlaceholderRadioDescriptionText : this.formattedLabels.wantSample.sampleRadioDescriptionText;
		},
		fallbackState() {
			return !this.selectedVariant ? this.stateIndicator : this.selectedVariant.ProcessIndicatorState;
		},
		isSampleOnly(){
			return [sampleAndPurchaseStates.IS_SAMPLE_ONLY, sampleAndPurchaseStates.IS_SAMPLE_AND_PURCHASE].includes(this.fallbackState);
		},
		showSampleOnlyComponent() {
			return this.dontKnowSize || this.isSampleOnly;
		},
		showAddToBasketButton() {
			if (this.externalPurchaseOnly) {
				const isNotBuy = this.action !== this.buyAction;
				return this.selectedVariant ? isNotBuy && !!this.action : isNotBuy;
			}

			return this.isSampleInBasket ? false : this.isSampleOnly;
		},
		externalPurchaseOnly() {
			return !!this.vm.BaseViewModel?.ExternalSiteBuyUrl;
		},
		showExternalPurchaseButton() {
			return this.vm.BaseViewModel?.ExternalSiteBuyUrl && !this.showAddToBasketButton;
		},
		insertExternalLink() {
			const whereToBuyText = this.vm.BaseViewModel
				?.ProductDetailsSettingsBlock?.StandardPackRadioWhereToBuyText;
			if (whereToBuyText !== undefined) {
				return whereToBuyText.replace(
					"{{ExternalSiteBuyUrl}}",
					`<a href="${this.vm.BaseViewModel?.ExternalSiteBuyUrl}">${
						this.vm.BaseViewModel?.ExternalBuyUrlLabel
					}</a>`
				);
			}
			return "";
		},
		isSampleInBasket() {
			if (this.selectedVariant !== null) {
				return this.selectedVariant.IsInBasket && !this.selectedVariant.SamplingRuleViolation;
			}
			return false;
		},
	},
	methods: {
		...mapMutations([
			'setLanguage',
		]),
		...mapActions([
			'addItemToBasket',
			'fetchVariants',
		]),
		// set action
		setActionBuy() {
			this.action = this.buyAction;
		},
		setActionSample() {
			this.action = this.sampleAction;
		},
		preSelectedSampleIfVariantsOne() {
			if (this.stateIndicator === sampleAndPurchaseStates.IS_SAMPLE_ONLY && this.variants.length === 1) {
				this.setActionSample();
			}
		},
		async addProductToBasket() {
			try {
				const payload = { productCodes: [this.selectedVariant.Item.Code], lineItemSource: 'ProductPage' };
				const response = await AddSampleToBasketService.addSampleToBasket(payload, this.language);
				if (response.data.errors.length === 0) {
					this.$eventBus.$emit('itemsAddedToTheBasket', { quantity: 1, displayName: this.selectedVariant.Item.DisplayName, basketItemCount: response.data.basketItemCount });
					track_add_to_cart(response.data);
				}
			} finally {
				const event = new CustomEvent(
					Events.ACTIVATE_FLY_OUT_BASKET,
					{}
				);
				document.dispatchEvent(event);
				await this.fetchVariants();
			}
		},
	},
	mounted() {
		this.setLanguage(this.language);
		this.preSelectedSampleIfVariantsOne();
	},
	watch: {
		selectedVariant() {
			if (!this.hcpProductLayout) {
				this.action = this.initialAction;
				this.initialAction = "";
			}
			else {
				this.setActionSample();
			}
			if(this.selectedVariant !== null && this.selectedVariant.IsSamplePlaceHolder) {
				this.setActionSample();
			}

			if(this.stateIndicator === sampleAndPurchaseStates.IS_SAMPLE_ONLY && this.selectedVariant) {
				this.setActionSample();
			}

			if (this.externalPurchaseOnly) {
				this.setActionBuy();
			}
		},
	}
}
</script>
